import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Container,
  Grid,
  Button,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DescriptionIcon from '@mui/icons-material/Description';
import DeleteIcon from '@mui/icons-material/Delete';
import SheetEditor from './SheetEditor';

const SheetsPage = () => {
  const [sheets, setSheets] = useState([
    { id: '1', name: 'Recruiting Contacts', lastModified: '2025-08-25' },
    { id: '2', name: 'Team Roster', lastModified: '2025-08-27' },
    { id: '3', name: 'Scouting Notes', lastModified: '2025-08-28' },
  ]);
  
  const [selectedSheet, setSelectedSheet] = useState(null);
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [newSheetName, setNewSheetName] = useState('');

  const handleSheetClick = (sheet) => {
    setSelectedSheet(sheet);
  };

  const handleBackToList = () => {
    setSelectedSheet(null);
  };

  const handleCreateSheet = () => {
    if (newSheetName.trim()) {
      const newSheet = {
        id: `sheet-${Date.now()}`,
        name: newSheetName,
        lastModified: new Date().toISOString().split('T')[0],
      };
      setSheets([...sheets, newSheet]);
      setNewSheetName('');
      setIsCreateDialogOpen(false);
      setSelectedSheet(newSheet);
    }
  };

  const handleDeleteSheet = (id, event) => {
    event.stopPropagation();
    setSheets(sheets.filter(sheet => sheet.id !== id));
  };

  if (selectedSheet) {
    return <SheetEditor sheet={selectedSheet} onBack={handleBackToList} />;
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 2, mb: 4 }}>
      <Paper sx={{ p: 2, mb: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h5" component="h1">
            Sheets
          </Typography>
          <Button 
            variant="contained" 
            color="primary" 
            startIcon={<AddIcon />}
            onClick={() => setIsCreateDialogOpen(true)}
          >
            Create New Sheet
          </Button>
        </Box>
        <Divider sx={{ mb: 3 }} />
        
        {sheets.length > 0 ? (
          <List>
            {sheets.map((sheet) => (
              <ListItem 
                key={sheet.id} 
                button 
                onClick={() => handleSheetClick(sheet)}
                sx={{
                  border: '1px solid #e0e0e0',
                  borderRadius: 1,
                  mb: 1,
                  '&:hover': { bgcolor: 'rgba(0, 43, 92, 0.04)' }
                }}
              >
                <ListItemIcon>
                  <DescriptionIcon color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary={sheet.name} 
                  secondary={`Last modified: ${sheet.lastModified}`} 
                />
                <IconButton 
                  edge="end" 
                  aria-label="delete" 
                  onClick={(e) => handleDeleteSheet(sheet.id, e)}
                >
                  <DeleteIcon />
                </IconButton>
              </ListItem>
            ))}
          </List>
        ) : (
          <Typography variant="body1">
            No sheets available. Create a new sheet to get started.
          </Typography>
        )}
      </Paper>

      {/* Create New Sheet Dialog */}
      <Dialog open={isCreateDialogOpen} onClose={() => setIsCreateDialogOpen(false)}>
        <DialogTitle>Create New Sheet</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Sheet Name"
            type="text"
            fullWidth
            variant="outlined"
            value={newSheetName}
            onChange={(e) => setNewSheetName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsCreateDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleCreateSheet} variant="contained" color="primary">
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default SheetsPage;
